<div class="horizontal-poll-graph">
  <div [ngClass]="isModal?'horizontal-poll-graph__graph-modal':'horizontal-poll-graph__graph'">
    @if (!isModal) {
      <div [id]="'tooltip-poll-graph-'+horizontalPollGraph.id"
        class="horizontal-poll-graph__tooltip-block">
        <p [id]="'tooltip-poll-graph-inner-'+horizontalPollGraph.id"
          class="horizontal-poll-graph__tooltip-content"></p>
      </div>
    }
  </div>
  @if (fromComponent !== 'graphReport') {
    <div class="horizontal-poll-graph__buttons">
      <button class="common-button__link"
        (click)="saveAsPng()"
        [disabled]="horizontalPollGraph.disabledSaveAsPng"
        [tooltipDisabled]="!horizontalPollGraph.showTooltip"
        [pTooltip]="'results-report.image-captured' | afTranslate"
        tooltipPosition="top"
        tooltipEvent="focus">
        <span class="common-button__link-text"
          [afTranslate]="horizontalPollGraph.textCaptureImage"></span>
      </button>
      @if (horizontalPollGraph.showExpandGraph) {
        <button class="common-button__link"
          (click)="expandGraph()">
          <span class="common-button__link-text"
            [afTranslate]="'results-report.show-complete-graph'">_Ver gráfica completa</span>
        </button>
      }
    </div>
  }
</div>
